// Copyright (c) 2020 WiseTime. All rights reserved.

import { combineEpics } from "redux-observable"
import fetchFavouriteActivityTypes from "./fetchFavouriteActivityTypes"
import fetchRecentActivityTypes from "./fetchRecentActivityTypes"
import searchActivityTypes from "./searchActivityTypes"
import createFavouriteActivityType from "./createFavouriteActivityType"
import deleteFavouriteActivityType from "./deleteFavouriteActivityType"
import reorderFavouriteActivityType from "./reorderFavouriteActivityType"
import persistOrderBy from "./persistOrderBy"
import loadOrderBy from "./loadOrderBy"
import persistRecentOrderBy from "./persistRecentOrderBy"
import loadRecentOrderBy from "./loadRecentOrderBy"
import persistViewMode from "./persistViewMode"
import loadViewMode from "./loadViewMode"
import getActivityType from "./getActivityType"
import { storagePrefix } from "../../../app/config"

export const SEARCH_ACTIVITY_TYPES_ORDER_BY_KEY = storagePrefix + "search_activity_types_order_by"
export const RECENT_ACTIVITY_TYPES_ORDER_BY_KEY = storagePrefix + "recent_activity_types_order_by"
export const ACTIVITY_TYPES_VIEW_MODE = storagePrefix + "activity_types_view_mode"

export default combineEpics(
  fetchRecentActivityTypes,
  fetchFavouriteActivityTypes,
  searchActivityTypes,
  createFavouriteActivityType,
  deleteFavouriteActivityType,
  reorderFavouriteActivityType,
  persistOrderBy,
  loadOrderBy,
  persistRecentOrderBy,
  loadRecentOrderBy,
  persistViewMode,
  loadViewMode,
  getActivityType,
)
